import React, { useState, useRef } from 'react'
import * as styles from './ResetPassword.css'
import { Redirect, Link, useParams } from 'react-router-dom'
import Flash from '../Flash'
import Logger from '../Logger'
import ALERT_TYPES from '../SharedConstants/AlertTypes'
import { BLUELEAF_LOGO_WHITE } from '../SharedConstants/Images'
import LoadingBar from 'react-top-loading-bar'
require('dotenv').config()

export default function ResetPasswordForm (props) {
  const { code, username } = useParams()
  const { CognitoIdentityLib } = props
  const [password, setPassword] = useState('')
  const [confirmation, setConfirmation] = useState('')
  const [alertType, setAlertType] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [redirect, setRedirect] = useState(false)
  const loadingRef = useRef(null)

  const handleSubmit = (e) => {
    Logger.start('Submit Reset Password', { code: code, username: username })
    setAlertType('')
    loadingRef.current.continuousStart()
    e.preventDefault()

    const userPool = new CognitoIdentityLib.CognitoUserPool({
      UserPoolId: process.env.USER_POOL_ID,
      ClientId: process.env.COGNITO_APP_ID
    })

    const userData = {
      Username: username,
      Pool: userPool
    }

    const cognitoUser = new CognitoIdentityLib.CognitoUser(userData)

    if (password !== confirmation) {
      setAlertType(ALERT_TYPES.UPDATE_FAILED)
      setErrorMessage('Password and confirmation password do not match')
      return
    }

    cognitoUser.confirmPassword(code, password, {
      onSuccess: (result) => {
        loadingRef.current.complete()
        Logger.done('Submit Reset Password', { code: code, username: username })

        Flash.setMessage('Your password has been reset, please sign in with the new password')
        setRedirect(true)
      },
      onFailure: (err) => {
        loadingRef.current.complete()
        Logger.error('Submit Reset Password', err)
        setAlertType(ALERT_TYPES.UPDATE_FAILED)
        setErrorMessage(err.message)
      }
    })
  }

  const renderAlert = () => {
    if (alertType === ALERT_TYPES.UPDATE_FAILED) {
      return (
        <div className={styles.alert}>
          { errorMessage }
        </div>
      )
    }
  }

  if (redirect) {
    return <Redirect id="login-redirect" to="/" />
  }

  return (
    <div className={styles.wrapper}>
      <LoadingBar color='#ffffff' ref={loadingRef} />
      <div className={styles.decorativeCircleTop}></div>
      <div className={styles.decorativeCircleBottom}></div>

      <div className={styles.mainContent}>
        <div className={styles.formWrapper}>
          <div className={styles.logoContainer}>
            <img
              alt="Blueleaf"
              src={ BLUELEAF_LOGO_WHITE }
              className={styles.logo}
            />
          </div>

          <div className={styles.formCard}>
            { renderAlert() }

            <div className={styles.formHeader}>
              <h2 className={styles.title}>Reset your password</h2>
              <p className={styles.subtitle}>Please create a new password for your account</p>
            </div>

            <form id="reset-password-form" onSubmit={handleSubmit}>
              <div className={styles.fieldGroup}>
                <label className={styles.label}>
                  New Password
                </label>
                <input
                  className={styles.input}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter new password"
                />
              </div>

              <div className={styles.fieldGroup}>
                <label className={styles.label}>
                  Confirm Password
                </label>
                <input
                  className={styles.input}
                  type="password"
                  value={confirmation}
                  onChange={(e) => setConfirmation(e.target.value)}
                  placeholder="Re-enter password"
                />
              </div>

              <input
                id="submit-btn"
                className={styles.submitButton}
                type="submit"
                value="Reset Password"
              />
              <Link id="sign-in-btn" className={styles.backToSignIn} to="/">
                Back to sign in
              </Link>
            </form>
          </div>

          <div className={styles.supportContainer}>
            <span className={styles.supportText}>
              Need help? <a href="mailto:vipsupport@blueleaf.com" className={styles.supportLink}>
                Contact support
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <p className={styles.footerText}>
          © 2010–2026 Blueleaf Wealth, Inc. All rights reserved. Patent pending.
        </p>
      </div>
    </div>
  )
}
